import { fg } from '@atlaskit/platform-feature-flags';

export const isQueryLikeWorkItemKey = (query: string): boolean => /^[A-Z0-9]{2,}-\d+$/i.test(query.trim());

const ISSUE_NAVIGATOR_URL = `/issues/?jql=${encodeURIComponent(
	'created >= -30d order by created DESC',
)}`;

const buildJiraJqlUrl = (jql: string, query: string) =>
	`/issues/?jql=${encodeURIComponent(jql)}&text=${encodeURIComponent(query)}`;

const buildJiraSearchUrl = (searchString: string, issueKeyLookup?: boolean) => {
	if (!issueKeyLookup && fg('rovo_search_update_work_items_link')) {
		const clauseField = isQueryLikeWorkItemKey(searchString) ? 'issuekey' : 'textfields';
		return `/issues/?jql=${clauseField} ~ "${encodeURIComponent(searchString)}*"`;
	}
	return `/jira/search?${new URLSearchParams({ searchString }).toString()}`;
};

export const buildJiraAdvancedSearchPath: (
	query: string,
	jql?: string | null,
	issueKeyLookup?: boolean,
) => string = (query: string, jql?: string | null, issueKeyLookup?: boolean): string => {
	const trimmedQuery = query.trim();

	if (jql) {
		return buildJiraJqlUrl(jql, query);
	}

	if (trimmedQuery) {
		return buildJiraSearchUrl(trimmedQuery, issueKeyLookup);
	}

	return ISSUE_NAVIGATOR_URL;
};

const buildRovoSearchUrl = (siteUrl?: string) => {
	const path = '/jira/rovo-search';

	if (!siteUrl) {
		return path;
	}
	return new URL(path, siteUrl || '').href;
};

// This function generates relative URL if base url is not available
export const generateJiraSearchUrl: (
	urlQueryParams: Record<string, string | string[] | boolean | undefined | null>,
	isSecondaryLink: boolean | undefined,
	customParams?: Record<string, string> | null,
	issueKeyLookup?: boolean,
) => string = (
	urlQueryParams: Record<string, string | string[] | boolean | undefined | null>,
	isSecondaryLink: boolean | undefined,
	customParams?: Record<string, string> | null,
	issueKeyLookup = true,
) => {
	const searchParams = new URLSearchParams(customParams || {});

	// This function assumes the text is in sync with JQL text field
	let queryString = searchParams.get('text') || urlQueryParams.text?.toString() || '';
	const jql = searchParams.get('jql') || (!isSecondaryLink && urlQueryParams.jql?.toString()) || '';

	// remove jql from params as it's already picked up
	searchParams.delete('jql');

	if (!isSecondaryLink) {
		Object.entries(urlQueryParams).forEach(([key, value]) => {
			// add current params if they are not in custom search params
			if (value !== undefined && value !== null && !searchParams.has(key)) {
				searchParams.set(key, String(value));
			}
		});
	}

	let url = isSecondaryLink
		? buildJiraAdvancedSearchPath(queryString, jql, issueKeyLookup)
		: buildRovoSearchUrl();

	const params = searchParams.toString();
	if (params) {
		url = url.concat(url.includes('?') ? '&' : '?').concat(params);
	}

	return url;
};
